import {initCommon} from "./common";
import {initElements} from "./elements";
import {initComponents} from "./components";

export const initApp = () => {
	initCommon();
	initElements();
	initComponents();
};
